import * as api from '@yandex-int/k-common/client/api';
import { showNetworkError } from 'platform-components';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { actions } from './actions';

function* referralCodeSaga() {
    try {
        const response: { ref_code: string } = yield call(api.getReferralCode);
        yield put(actions.loadReferralCodeSuccess(response.ref_code));
    } catch (error) {
        yield put(showNetworkError());
    }
}

export function* referralCodeSagasWatcher() {
    yield all([takeLatest(actions.loadReferralCode, referralCodeSaga)]);
}
